// Consts
export const SET_ERRORS = "answerLogin/SET_ERRORS";
export const CHANGE_FORM = "answerLogin/CHANGE_FORM";
export const INIT = "answerLogin/INIT";
export const SET_AUTH_ERROR_MESSAGE_TYPE =
  "answerLogin/SET_AUTH_ERROR_MESSAGE_TYPE";

// Actions
export const setErrors = errors => ({
  type: SET_ERRORS,
  errors
});

export const changeForm = (key, value) => ({
  type: CHANGE_FORM,
  key,
  value
});

export const init = () => ({
  type: INIT
});

export const setAuthErrorType = authErrorType => ({
  type: SET_AUTH_ERROR_MESSAGE_TYPE,
  authErrorType
});

// Reducers
const initialState = {
  authErrorType: null,
  errors: [],
  password: ""
};

const answerLogin = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_ERRORS: {
      return { ...state, errors: action.errors };
    }

    case CHANGE_FORM: {
      const { key, value } = action;
      return { ...state, [key]: value };
    }

    case INIT: {
      return initialState;
    }

    case SET_AUTH_ERROR_MESSAGE_TYPE: {
      const { authErrorType } = action;
      return { ...state, authErrorType };
    }

    default:
      return state;
  }
};

export default answerLogin;



// WEBPACK FOOTER //
// ./src/redux/modules/answer/answerLogin.js